/*
 * Fast Buy + Gift
 * -----------------------------------------------------------------------------
 * Yastık hediye kampanyasindaki yataklarda "Hemen Satin Al" butonu.
 * Native dynamic checkout sepeti atladigi icin hediye eklenmiyordu; bu buton
 * secili yatagi + dogru sayida ucretsiz yastigi sepete ekleyip dogrudan
 * odemeye goturur.
 *
 * Hediye: olcu genisligi >= threshold ise (cift kisilik) 2 yastik + 195x215 yorgan,
 * degilse 1 yastik + 155x215 yorgan; yatak adediyle carpilir.
 * Olcu olmayan varyant (width 0) -> hediye yok.
 */
if (!customElements.get('fast-buy-gift')) {
  class FastBuyGift extends HTMLElement {
    constructor() {
      super();
      this.pillowId = parseInt(this.getAttribute('data-pillow-id'));
      this.quiltSingleId = parseInt(this.getAttribute('data-quilt-single-id'));
      this.quiltDoubleId = parseInt(this.getAttribute('data-quilt-double-id'));
      this.threshold = parseInt(this.getAttribute('data-threshold')) || 140;
      this.formId = this.getAttribute('data-form-id');
      try {
        this.widths = JSON.parse(this.querySelector('.fast-buy-gift__widths').textContent);
      } catch (e) {
        this.widths = {};
      }
      this.button = this.querySelector('[data-fast-buy]');
    }

    connectedCallback() {
      if (this.button) {
        this.button.addEventListener('click', this.onClick.bind(this));
      }
    }

    getForm() {
      return document.getElementById(this.formId) || (this.button && this.button.closest('form'));
    }

    onClick(event) {
      event.preventDefault();

      const form = this.getForm();
      if (!form) return;

      const idInput = form.querySelector('[name="id"]');
      const bedId = idInput ? parseInt(idInput.value) : null;
      if (!bedId) return;

      const qtyInput = form.querySelector('[name="quantity"]');
      let bedQty = qtyInput ? parseInt(qtyInput.value) : 1;
      if (!bedQty || bedQty < 1) bedQty = 1;

      const width = parseInt(this.widths[bedId]) || 0;
      const items = [{ id: bedId, quantity: bedQty }];
      if (width > 0) {
        const isDouble = width >= this.threshold;
        const pillowQty = (isDouble ? 2 : 1) * bedQty;
        const quiltId = isDouble ? this.quiltDoubleId : this.quiltSingleId;
        if (this.pillowId) items.push({ id: this.pillowId, quantity: pillowQty });
        if (quiltId) items.push({ id: quiltId, quantity: bedQty });
      }

      // Özel ödeme sayfası açıksa: yatak + hediyesi doğrudan oraya gider, sepete dokunulmaz.
      if (window.customCheckout && window.customCheckout.enabled()) {
        window.customCheckout.go({ items });
        return;
      }

      this.setLoading(true);

      const cartUrl = theme.routes.cart_url || '/cart';
      const clearUrl = cartUrl.replace(/\/$/, '') + '/clear.js';
      const checkoutUrl = cartUrl.replace(/\/cart(\?.*)?$/, '/checkout');

      // "Hemen Satin Al" = sadece bu yatak + hediyesi. Once sepeti temizle ki
      // eski sepet urunleri odemeye gelmesin, sonra ekle ve checkout'a git.
      fetch(clearUrl, { ...theme.utils.fetchConfig('javascript') })
        .then(() => fetch(`${theme.routes.cart_add_url}`, {
          ...theme.utils.fetchConfig('javascript'),
          body: JSON.stringify({ items })
        }))
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState && parsedState.status) {
            console.log('[fast-buy-gift] eklenemedi', parsedState);
            this.setLoading(false);
            return;
          }
          window.location.href = checkoutUrl;
        })
        .catch((error) => {
          console.log('[fast-buy-gift]', error);
          this.setLoading(false);
        });
    }

    setLoading(on) {
      if (!this.button) return;
      this.button.setAttribute('aria-busy', on ? 'true' : 'false');
      this.button.disabled = on;
    }
  }
  customElements.define('fast-buy-gift', FastBuyGift);
}
